/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkImportFacilityServiceAreasResponse } from './BulkImportFacilityServiceAreasResponse';
import {
    BulkImportFacilityServiceAreasResponseFromJSON,
    BulkImportFacilityServiceAreasResponseFromJSONTyped,
    BulkImportFacilityServiceAreasResponseToJSON,
    BulkImportFacilityServiceAreasResponseToJSONTyped,
} from './BulkImportFacilityServiceAreasResponse';

/**
 * 
 * @export
 * @interface BulkImportFacilityServiceAreas200Response
 */
export interface BulkImportFacilityServiceAreas200Response {
    /**
     * 
     */
    data?: BulkImportFacilityServiceAreasResponse;
}

/**
 * Check if a given object implements the BulkImportFacilityServiceAreas200Response interface.
 */
export function instanceOfBulkImportFacilityServiceAreas200Response(value: object): value is BulkImportFacilityServiceAreas200Response {
    return true;
}

export function BulkImportFacilityServiceAreas200ResponseFromJSON(json: any): BulkImportFacilityServiceAreas200Response {
    return BulkImportFacilityServiceAreas200ResponseFromJSONTyped(json, false);
}

export function BulkImportFacilityServiceAreas200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkImportFacilityServiceAreas200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : BulkImportFacilityServiceAreasResponseFromJSON(json['data']),
    };
}

export function BulkImportFacilityServiceAreas200ResponseToJSON(json: any): BulkImportFacilityServiceAreas200Response {
    return BulkImportFacilityServiceAreas200ResponseToJSONTyped(json, false);
}

export function BulkImportFacilityServiceAreas200ResponseToJSONTyped(value?: BulkImportFacilityServiceAreas200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BulkImportFacilityServiceAreasResponseToJSON(value['data']),
    };
}

